export default __webpack_public_path__ + "static/media/form-img-1.fec1bda7.png";